import { apiRequest } from './http-client';

let cachedGuestToken: string | null = null;

async function signGuestJwt(): Promise<string | null> {
  const secret =
    (typeof __FINPAY_GUEST_TOKEN_SECRET__ !== 'undefined'
      ? __FINPAY_GUEST_TOKEN_SECRET__
      : '') || (process.env.REACT_APP_AWS_GUEST_TOKEN_SECRET ?? '');
  const audience =
    (typeof __FINPAY_GUEST_TOKEN_AUDIENCE__ !== 'undefined'
      ? __FINPAY_GUEST_TOKEN_AUDIENCE__
      : '') || (process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID ?? '');
  const subject =
    (typeof __FINPAY_GUEST_TOKEN_SUBJECT__ !== 'undefined'
      ? __FINPAY_GUEST_TOKEN_SUBJECT__
      : '') || (process.env.REACT_APP_AWS_USER_POOL_ID ?? '');

  if (!secret || !audience || !subject) {
    return null;
  }

  const { SignJWT } = await import('jose');
  const key = new TextEncoder().encode(secret);
  return new SignJWT({})
    .setProtectedHeader({ alg: 'HS256', typ: 'JWT' })
    .setIssuedAt()
    .setAudience(audience)
    .setSubject(subject)
    .sign(key);
}

export async function resolveAuthToken(
  apiBase: string,
  explicitToken?: string | null
): Promise<string> {
  if (explicitToken?.trim()) {
    return explicitToken.trim();
  }

  if (cachedGuestToken) {
    return cachedGuestToken;
  }

  const signed = await signGuestJwt();
  if (!signed) {
    throw new Error(
      'Missing api-token attribute and guest token is not configured for this build'
    );
  }

  const guestSession = await apiRequest<{ token?: string }>(
    apiBase,
    '/user/v2/guest',
    { method: 'POST', authToken: signed }
  );

  const sessionToken = guestSession.entity?.token;
  if (guestSession.hasErrors || !sessionToken) {
    throw new Error(
      guestSession.errorMessage ?? 'Unable to obtain guest session token'
    );
  }

  cachedGuestToken = sessionToken;
  return cachedGuestToken;
}

export function clearAuthTokenCache(): void {
  cachedGuestToken = null;
}
